import { forwardRef } from 'react'
import { cva } from 'class-variance-authority'
import { cn } from '@vgw/tailwind-merger'
import { ButtonBaseProps, ButtonBase } from './button-base'
import { ButtonFilledProps } from './button-filled'

const buttonGhostVariants = cva(
  [
    'border-gradient-mask',
    'bg-transparent',
    'before:bg-transparent',
    'before:p-(--border-width-button-ghost)',
  ],
  {
    variants: {
      variant: {
        primary: [
          'rounded-button-ghost',
          'text-button-ghost-content-primary',
          'hover:bg-button-ghost-surface-hover',
          'active:bg-button-ghost-surface-active',
          'active:opacity-92',
          'disabled:bg-surface-disabled',
          'disabled:text-content-disabled',
          'disabled:rounded-button-ghost',
          'disabled:active:opacity-100',
          'before:rounded-button-ghost',
        ],
        secondary: [
          'rounded-button-ghost',
          'text-button-ghost-content',
          'hover:bg-button-ghost-surface-hover',
          'active:bg-button-ghost-surface-active',
          'active:opacity-92',
          'disabled:bg-surface-disabled',
          'disabled:text-content-disabled',
          'disabled:rounded-button-ghost',
          'disabled:active:opacity-100',
          'before:rounded-button-ghost',
        ],
        tertiary: [
          'rounded-button-ghost',
          'text-button-ghost-content-tertiary',
          'hover:bg-button-ghost-surface-tertiary-hover',
          'active:bg-button-ghost-surface-tertiary-active',
          'active:opacity-92',
          'disabled:bg-surface-disabled',
          'disabled:text-content-disabled',
          'disabled:rounded-button-ghost',
          'disabled:active:opacity-100',
          'before:rounded-button-ghost',
        ],
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
)

export type ButtonGhostProps = ButtonBaseProps

export const ButtonGhost = forwardRef<HTMLButtonElement, ButtonGhostProps>(
  ({ className, variant = 'primary', ...props }: ButtonFilledProps, ref) => {
    return (
      <ButtonBase
        {...props}
        className={cn(buttonGhostVariants({ variant, className }))}
        variant={variant}
        ref={ref}
      />
    )
  },
)

ButtonGhost.displayName = 'ButtonGhost'
